export const USER_GROUPS = 'userGroups';

export const USER_GROUPS_ACTIONS_NAME = {
  searchCountries: `${USER_GROUPS}/searchCountries`,
  searchAreas: `${USER_GROUPS}/searchAreas`,
  searchAreaLinks: `${USER_GROUPS}/searchAreaLinks`,
  createArea: `${USER_GROUPS}/createArea`,
  updateArea: `${USER_GROUPS}/updateArea`,
  deleteArea: `${USER_GROUPS}/deleteArea`,
  saveAreaCountries: `${USER_GROUPS}/saveAreaCountries`,
  searchCustomsItems: `${USER_GROUPS}/searchCustomsItems`,
  searchCustomsLinks: `${USER_GROUPS}/searchCustomsLinks`,
  createCustomsGroup: `${USER_GROUPS}/createCustomsGroup`,
  updateCustomsGroup: `${USER_GROUPS}/updateCustomsGroup`,
  deleteCustomsGroup: `${USER_GROUPS}/deleteCustomsGroup`,
  saveCustomsGroupItems: `${USER_GROUPS}/saveCustomsGroupItems`,
  searchTransportGroups: `${USER_GROUPS}/searchTransportGroups`,
  searchTransportItems: `${USER_GROUPS}/searchTransportItems`,
  searchTransportLinks: `${USER_GROUPS}/searchTransportLinks`,
  createTransportGroup: `${USER_GROUPS}/createTransportGroup`,
  updateTransportGroup: `${USER_GROUPS}/updateTransportGroup`,
  deleteTransportGroup: `${USER_GROUPS}/deleteTransportGroup`,
  saveTransportGroupItems: `${USER_GROUPS}/saveTransportGroupItems`,
  searchGoodsGroups: `${USER_GROUPS}/searchGoodsGroups`,
  fetchGoodsGroupById: `${USER_GROUPS}/fetchGoodsGroupById`,
  searchGoodsItems: `${USER_GROUPS}/searchGoodsItems`,
  searchGoodsLinks: `${USER_GROUPS}/searchGoodsLinks`,
  createGoodsGroup: `${USER_GROUPS}/createGoodsGroup`,
  updateGoodsGroup: `${USER_GROUPS}/updateGoodsGroup`,
  deleteGoodsGroup: `${USER_GROUPS}/deleteGoodsGroup`,
  saveGoodsGroupGoods: `${USER_GROUPS}/saveGoodsGroupGoods`,
  searchGoodsUnits: `${USER_GROUPS}/searchGoodsUnits`,
} as const;

export const USER_GROUPS_MUTATIONS_NAME = {
  setAreas: `${USER_GROUPS}/setAreas`,
  setCountries: `${USER_GROUPS}/setCountries`,
  setAreaCountryLinks: `${USER_GROUPS}/setAreaCountryLinks`,
  addArea: `${USER_GROUPS}/addArea`,
  updateArea: `${USER_GROUPS}/updateArea`,
  deleteArea: `${USER_GROUPS}/deleteArea`,
  setCustomsItems: `${USER_GROUPS}/setCustomsItems`,
  setTransportGroups: `${USER_GROUPS}/setTransportGroups`,
  setTransportItems: `${USER_GROUPS}/setTransportItems`,
  setGoodsGroups: `${USER_GROUPS}/setGoodsGroups`,
  addGoodsGroup: `${USER_GROUPS}/addGoodsGroup`,
  updateGoodsGroup: `${USER_GROUPS}/updateGoodsGroup`,
  deleteGoodsGroup: `${USER_GROUPS}/deleteGoodsGroup`,
  setGoodsItems: `${USER_GROUPS}/setGoodsItems`,
  setGoodsUnits: `${USER_GROUPS}/setGoodsUnits`,
} as const;

export const USER_GROUPS_GETTERS_NAME = {
  getAreas: `${USER_GROUPS}/getAreas`,
  getCountries: `${USER_GROUPS}/getCountries`,
  getAreaCountryLinks: `${USER_GROUPS}/getAreaCountryLinks`,
  getCustomsItems: `${USER_GROUPS}/getCustomsItems`,
  getTransportGroups: `${USER_GROUPS}/getTransportGroups`,
  getTransportItems: `${USER_GROUPS}/getTransportItems`,
  getGoodsGroups: `${USER_GROUPS}/getGoodsGroups`,
  getGoodsItems: `${USER_GROUPS}/getGoodsItems`,
  getGoodsUnits: `${USER_GROUPS}/getGoodsUnits`,
} as const;
